<rx-upload-zone (checkedChange)="uploadFile($event)">
  <span rxUpload (checkedChange)="uploadFile($event)" multiple="true">click here</span>
</rx-upload-zone>
